export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 3.25a.75.75 0 01.75.75v15.25H20a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75V4A.75.75 0 014 3.25z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.52 15.576a.75.75 0 01-.096-1.056l5-6a.75.75 0 01.962-.163L13.792 11l4.598-6.437a.75.75 0 111.22.872l-5 7a.75.75 0 01-.996.207l-4.45-2.67-4.588 5.507a.75.75 0 01-1.056.096z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};